import {
  FETCH_UPDATE_DOCUMENTS_REQUEST,
  FETCH_UPDATE_DOCUMENTS_SUCCESS,
  FETCH_UPDATE_DOCUMENTS_FALUIRE,
} from './updateDocumentsTypes'

const initialState = {
  loading: false,
  updateDocumentsInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_UPDATE_DOCUMENTS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPDATE_DOCUMENTS_SUCCESS : return {
      ...state,
      updateDocumentsInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPDATE_DOCUMENTS_FALUIRE : return {
      ...state,
      loading: false,
      updateDocumentsInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
